import { useLocation } from "react-router-dom";
// material
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import Page from '../../../components/Page';
import ApiMasterDetailsComponent from "../../../components/SidebarMenuComponents/MasterComponent/ApiMasterDetailsComponent";
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function ApiMasterDetailPage() {
    const location = useLocation();
    const  {apiMaster}  = location.state;

    return (
        <Page title="API Master Details| tiketic" >
            <Typography variant="h5" color="#E7000B" marginLeft={3} marginTop={1} >
               API Master Details
            </Typography>

            <ContentStyle>
                <ApiMasterDetailsComponent apiMaster={apiMaster} />
            </ContentStyle>
        </Page>
    );
}

